import { render } from "./App.vue?vue&type=template&id=71ec4a07"
const script = {}

import "./App.vue?vue&type=style&index=0&id=71ec4a07&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/Philippines/phi_spread_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__